import { render } from "./RegionsCalc.vue?vue&type=template&id=633850a5&scoped=true"
import script from "./RegionsCalc.vue?vue&type=script&lang=js"
export * from "./RegionsCalc.vue?vue&type=script&lang=js"

import "./RegionsCalc.vue?vue&type=style&index=0&id=633850a5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-633850a5"

export default script